import { API } from "../api";
import { mapInvestorRealEstateRequest } from "../../utils/investorRealEstateAdapter";

function transformListResponse(responseData) {
  const data = responseData?.data;
  return {
    items: (data?.items || []).map(mapInvestorRealEstateRequest).filter(Boolean),
    pagination: data?.pagination || {},
  };
}

export const investorRealEstateApi = API.injectEndpoints({
  endpoints: (builder) => ({
    listRealEstateRequests: builder.query({
      query: (params = {}) => ({
        url: "/investors/real-estate",
        method: "GET",
        params,
      }),
      transformResponse: transformListResponse,
      providesTags: (result) =>
        result?.items?.length
          ? [
              ...result.items.map((item) => ({
                type: "RealEstateRequest",
                id: item.reference || item.id,
              })),
              { type: "RealEstateRequests", id: "LIST" },
            ]
          : [{ type: "RealEstateRequests", id: "LIST" }],
    }),
    getRealEstateRequest: builder.query({
      query: (requestReference) => ({
        url: `/investors/real-estate/${encodeURIComponent(requestReference)}`,
        method: "GET",
      }),
      transformResponse: (responseData) => mapInvestorRealEstateRequest(responseData?.data),
      providesTags: (_r, _e, id) => [{ type: "RealEstateRequest", id }],
    }),
    createRealEstateRequest: builder.mutation({
      query: (body) => ({
        url: "/investors/real-estate",
        method: "POST",
        body,
      }),
      transformResponse: (responseData) => mapInvestorRealEstateRequest(responseData?.data),
      invalidatesTags: [
        { type: "RealEstateRequests", id: "LIST" },
        { type: "StaffRealEstateRequests", id: "LIST" },
        { type: "StaffRealEstateSummary", id: "SUMMARY" },
      ],
    }),
    cancelRealEstateRequest: builder.mutation({
      query: ({ requestReference, reason }) => ({
        url: `/investors/real-estate/${encodeURIComponent(requestReference)}/cancel`,
        method: "POST",
        body: reason ? { reason } : {},
      }),
      transformResponse: (responseData) => mapInvestorRealEstateRequest(responseData?.data),
      invalidatesTags: (_r, _e, { requestReference }) => [
        { type: "RealEstateRequests", id: "LIST" },
        { type: "RealEstateRequest", id: requestReference },
        { type: "StaffRealEstateRequests", id: "LIST" },
        { type: "StaffRealEstateSummary", id: "SUMMARY" },
      ],
    }),
  }),
});

export const {
  useListRealEstateRequestsQuery,
  useGetRealEstateRequestQuery,
  useCreateRealEstateRequestMutation,
  useCancelRealEstateRequestMutation,
} = investorRealEstateApi;
